module.exports = __webpack_public_path__ + "img/insta-9.a770f999.jpg";